

const resetState = () => {
    return {
        surveyFlow: [],
        surveySetup: {},
        currentFocusIndex: false,
        currentFocusIndexHasErrors: false
    }
}

export default resetState